import { render, staticRenderFns } from "./TheSideBar.vue?vue&type=template&id=458ea9f6&scoped=true&"
import script from "./TheSideBar.vue?vue&type=script&lang=js&"
export * from "./TheSideBar.vue?vue&type=script&lang=js&"
import style0 from "./TheSideBar.vue?vue&type=style&index=0&id=458ea9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458ea9f6",
  null
  
)

export default component.exports